import * as z from "zod";

export const getMobileUploadResult = {
  name: "getMobileUploadResult" as const,
  input: z.object({ token: z.string() }),
  output: z.object({
    imageUrls: z.array(z.string()),
    completed: z.boolean(),
    expired: z.boolean(),
  }),
};
